import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import {
  AbContainer,
  AbTitle,
  AbDescription,
  AbSection,
  AbLink,
} from '../../ui';
import { Spacing } from '../../../helpers/shared-props';
import { computed } from 'vue-demi';
interface HelpCardData {
  url: string;
  image: string;
  alt?: string;
  title: string;
  description: string;
}
interface Props {
  data: {
    title?: string;
    description?: string;
    items: HelpCardData[];
    spacing?: Spacing;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionSmallBlocks',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    title?: string;
    description?: string;
    items: HelpCardData[];
    spacing?: Spacing;
  };
};



const helpCards = computed(() =>
  Array.isArray(props.data) ? props.data : props.data.items
);

return { __sfc: true,props, helpCards, CdnImg, AbContainer, AbTitle, AbDescription, AbSection, AbLink }
}

})